import { EActiveTab } from '../../types/tabs';
export var defaultState = EActiveTab.Authentication;